import React, { useRef, useState } from "react";
import PulseLoader from "react-spinners/PulseLoader";
import { truncateText } from "../../utils/truncate";

interface UploderLogoComponentProps {
  name?: any;
  onChange?: (file: File) => void;
  defaultValue?: any;
  errors?: any;
  onResponse?: any;
  isLoading?: boolean;
  labeltxt?: string;
  disableInputLogo?: boolean;
  value?: any;
  isReset?: boolean;
  accept?: string;
}

const UploderLogoComponent: React.FC<UploderLogoComponentProps> = ({
  name,
  onChange,
  value,
  errors,
  onResponse,
  isLoading,
  labeltxt,
  disableInputLogo,
  isReset,
  accept = "image/jpeg, image/png",
}: any) => {
  const [formData, setFormData] = useState(new FormData());
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [selectedImage, setSelectedImage] = useState<string | undefined>(
    undefined
  );
  const [nameFile, setFileName] = useState<string | undefined>(undefined);

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (file) {
      const newFormData = new FormData();
      newFormData.append("id_card", file);
      setFormData(newFormData);

      const imageDataUrl = URL.createObjectURL(file);
      setSelectedImage(imageDataUrl);
      setFileName(file.name);
    } else {
      setSelectedImage(undefined);
      setFileName(undefined);
    }

    if (onChange) {
      onChange(file);
    } else {
      setFormData(new FormData());
    }
  };

  return (
    <div
      className={` ${
        errors
          ? "bg-red-100 rounded-lg border-2 border-red-300 "
          : "flex hover:bg-gray-100 rounded-lg border-2 border-gray-300 bg-gray-50 items-center justify-center w-full "
      }`}
    >
      <label
        htmlFor={name}
        className={`flex  items-start w-full h-10 rounded-lg ${
          disableInputLogo ? "cursor-not-allowed" : "cursor-pointer"
        }`}
      >
        {isLoading ? (
          <PulseLoader color="#477CD1" />
        ) : (
          <>
            <span className="whitespace-nowrap h-[40px] text-Body-OneLine/14/Medium flex items-center justify-center text-center py-[10px] px-[20px] bg-primary-800 text-white focus:outline-none  border-gray-300 rounded-r-lg border-l">
              انتخاب فایل
            </span>
            <div className="flex flex-row items-start justify-end ">
              {!isReset && selectedImage ? (
                <p className=" ">
                  <span className="text-BodyText/14/Bold text-center flex mr-5 mt-2">
                    {nameFile && truncateText(nameFile, 15)}
                  </span>
                </p>
              ) : (
                !errors && (
                  <p className=" ">
                    <span className="text-BodyText/14/Medium text-center flex mr-5 mt-2">
                      {labeltxt && truncateText(labeltxt, 15)}
                    </span>
                  </p>
                )
              )}
              <p className=" ">
                {errors && !selectedImage ? (
                  <span className="text-BodyText/14/Bold text-center flex mr-5 mt-2 text-red-600">
                    انتخاب لوگو الزامی است.
                  </span>
                ) : (
                  ""
                )}
              </p>
            </div>
            <input
              id={name}
              type="file"
              className="hidden"
              onChange={handleFileChange}
              ref={fileInputRef}
              disabled={disableInputLogo}
              accept={accept}
              value={value}
            />
          </>
        )}
      </label>
    </div>
  );
};

export default UploderLogoComponent;
